var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"pa-3"},[_c('v-card-title',[_vm._v(" Localizacion GPS "),_c('v-spacer')],1),_c('v-row',[_c('v-col',[_c('v-btn',{class:[
            {
              'disabled-button': _vm.currentView != 'UbicacionEnVivo',
              'enabled-button': _vm.currentView === 'UbicacionEnVivo',
            },
            'mr-1',
            'ml-3',
            'mb-3',
          ],attrs:{"color":"primary"},on:{"click":function($event){_vm.currentView = 'UbicacionEnVivo'}}},[_vm._v(" Ubicación en Vivo ")]),_c('v-btn',{class:[
            {
              'disabled-button': _vm.currentView != 'VisitasGps',
              'enabled-button': _vm.currentView === 'VisitasGps',
            },
            'mr-1',
            'ml-3',
            'mb-3',
          ],attrs:{"color":"primary"},on:{"click":function($event){_vm.currentView = 'VisitasGps'}}},[_vm._v(" Visitas ")])],1)],1),(_vm.currentView === 'VisitasGps')?_c('VisitasGps'):_vm._e(),(_vm.currentView === 'UbicacionEnVivo')?_c('UbicacionEnVivo'):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }